import { UPDATE_FORM, RESET_FORM } from "../actions/HierarchyForm.action";

const Fyquarters = {
  Q2: [7, 8, 9],
  Q3: [10, 11, 12],
  Q4: [1, 2, 3],
  Q1: [4, 5, 6],
}

const getInitialState = () => {
  const now = new Date();
  const month = now.getMonth() + 1;

  const quarter = Object.entries(Fyquarters).find(([_, months]) =>
    months.includes(month)
  )?.[0] || "Q1";

  const year = now.getFullYear();
  const fy_year = month >= 4 ? `${year}-${year + 1}` : `${year - 1}-${year}`;

  return {
    month,
    fy_year,
    quarter,
  };
};

const HierarchyformReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case UPDATE_FORM:
      return { ...state, ...action.payload };

    case RESET_FORM:
      return getInitialState();

    default:
      return state;
  }
};

export default HierarchyformReducer;
